import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import OrderStatus from "../../Utility/Crud/OrderStatus";
import * as MUIColors from "@mui/material/colors";
import MainContext from "../../Context/MainContext/MainContext";

export default class ChipOrderStatus extends Chip {
  static contextType = MainContext; // For legacy class components
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const colorObject = this.props.orderStatus
      ? this.context.colorsIndexed[this.props.orderStatus.colorId]
      : null;
    const color = this.props.orderStatus
      ? MUIColors[colorObject.hue][colorObject.shade]
      : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";
    const iconName = OrderStatus.getIconName(this.props.orderStatus);

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {OrderStatus.getIcon({
          fontSize: "small",
          sx: { color: iconColor },
          icon: iconName,
        })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The orderStatus description.
   */
  getLabel() {
    return this.props.orderStatus
      ? OrderStatus.getDisplayName(this.props.orderStatus)
      : "None";
  }
}
